import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Icon } from 'src/assets/images/fortune/ic-nookpoint.svg';
import { FadeInImage } from 'src/components/shared/FadeInImage';
import { formatNumber } from 'src/lib/format-number';
import { catalogIconUrl } from 'src/models/catalog/CatalogItem';
import { FortuneExchangedItem } from 'src/models/fortune/FortuneExchangedItem';
import { formatDate } from '../helper';
import { ReceiveStatus } from '../ReceiveStatus';

interface FortuneHistoryDetailContentProps {
  exchangedItem: FortuneExchangedItem;
}

export const FortuneHistoryDetailContent: React.FC<FortuneHistoryDetailContentProps> = ({
  exchangedItem
}) => {
  const { t, i18n } = useTranslation(['fortune', 'translation']);
  const { item, change_time, deliver_time } = exchangedItem;
  const changeDateString = formatDate(t, change_time);
  const deliverDateString = deliver_time ? formatDate(t, deliver_time) : undefined;
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #938666;
        font-size: 12px;
        text-align: center;

        @media screen and (max-width: 374px) {
          font-size: 14px;
        }
        .label {
          font-size: 20px;
          color: #493a31;
          margin-bottom: 8px;
        }
        .used-point-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin: 0 0 16px;
        }
        .used-point-text {
          font-size: 12px;
          color: #897a66;
          margin: 0 0 2px;
        }
        .used-point-value {
          font-size: 16px;
          margin-left: 2px;
        }
        .date-container {
          font-size: 12px;
          margin: 4px 0 0;
          p {
            margin: 0 0 2px;
          }
        }
        .notice {
          font-size: 10px;
          color: #ec8e00;
          margin: 4px 0 0;
        }
      `}
    >
      <FadeInImage
        src={catalogIconUrl(item.icon)}
        width={128}
        height={128}
        style={{ width: '128px', height: '128px' }}
        ariaLabel={t('translation:aria_item_image')}
      />
      <p className="label">{item.label}</p>
      <p className="used-point-text">{t('consumed_points')}</p>
      <div className="used-point-container">
        <Icon width={24} height={24} />
        <p className="used-point-value">{formatNumber(item.point, i18n.language)}</p>
      </div>

      <ReceiveStatus received={!!deliver_time} />

      <div className="date-container">
        <p>{t('change_time', { date: changeDateString })}</p>
        {deliverDateString && <p>{t('deliver_time', { date: deliverDateString })}</p>}
      </div>

      {!deliver_time && <p className="notice">{t('notice_conditions_to_receive')}</p>}
    </div>
  );
};
